import React, { useState, useEffect, useCallback, useContext } from "react";
import envContext from "../context/EnvContext";

const Amount = (props) => {
	const [amount, setAmount] = useState(0);
	const [error, setError] = useState("none");
	const env = useContext(envContext);

	// <<< Production Urls >>>

	//production env assignments
	// const { host } = env.pro;

	// let url = `${host}/home/update_price_item_react/${props.item.id}/${
	// 	props.start
	// }/${props.end}/${props.unit === 0 || props.unit === "" ? 1 : props.unit}`;

	// <<< Dev env assignment >>>
	const { proto } = env.dev;

	let url = `${proto}//www.mcclearyrentals.com/home/update_price_item_react/${
		props.item.id
	}/${props.start}/${props.end}/${
		props.unit === 0 || props.unit === "" ? 1 : props.unit
	}`;

	const fetchAmountData = useCallback(async () => {
		const amount = await fetch(url);
		const responseJson = await amount.json();
		if (typeof responseJson === "number") {
			setAmount(responseJson);
		} else {
			setError("block");
		}
	}, [url]);

	useEffect(() => {
		if (props.item.ppd > 0) {
			fetchAmountData();
		}
	}, [props.start, props.end, fetchAmountData, props.item.ppd]);

	if (amount !== 0 || props.item.sell_p !== 0) {
		return (
			<div className="widget price text-center">
				<h3 id="price_heading">
					{props.unit === 0 ? "Out Of Stock For Today" : "In Stock"}
				</h3>
				<h4 id="price_heading">
					{" "}
					{amount !== 0 ? "Price Per Day" : ""}
					{amount !== 0 && parseInt(props.item.sell_p) !== 0 ? " | " : ""}
					{parseInt(props.item.sell_p) !== 0 ? " Sell Price" : ""}
				</h4>
				<p id="rent_price">
					<i className="fa fa-usd" aria-hidden="true"></i>
					{amount !== 0 ? amount.toFixed(2) : ""}
					{amount !== 0 && parseInt(props.item.sell_p) !== 0 ? " - " : ""}
					{parseInt(props.item.sell_p) !== 0
						? parseInt(props.item.sell_p).toFixed(2)
						: amount !== 0 && parseInt(props.item.sell_p) !== 0}
				</p>
			</div>
		);
	} else {
		return (
			<div style={{ display: error }}>
				<div className="widget price text-center">
					<h4 id="price_heading">Price Per Day</h4>
					<p id="rent_price">An error occoured while fetching the data</p>
				</div>
			</div>
		);
	}
};

export default Amount;
